module.exports = __webpack_public_path__ + "img/scence3.f82e3608.jpg";